import { Modal, Pressable, StyleSheet, Text, View } from 'react-native';
import { getResponsiveSize } from 'utils/index';

import { ResetPinMessageModalProps } from 'components/Pin/ResetPinMessageModal';

export const WebResetPinMessageModal = ({
  isOpen,
  type = 'success',
  title,
  message,
  onClose,
}: ResetPinMessageModalProps): React.ReactNode => {
  if (!isOpen) return null;

  const modalTitle = title ?? (type === 'error' ? 'Ops!' : 'PIN redefinido');

  const modalMessage =
    message ??
    (type === 'error'
      ? 'Não foi possível redefinir o PIN. Tente novamente mais tarde.'
      : 'Um novo PIN foi gerado e enviado para seu e-mail.');

  return (
    <Modal visible={isOpen} transparent animationType="fade">
      <View style={styles.overlay}>
        <View style={styles.container}>
          <Text style={styles.title}>{modalTitle}</Text>

          <Text style={styles.text}>{modalMessage}</Text>

          <Pressable accessibilityRole="button" style={styles.closeBtn} onPress={onClose}>
            <Text style={styles.closeBtnText}>Fechar</Text>
          </Pressable>
        </View>
      </View>
    </Modal>
  );
};

const styles = StyleSheet.create({
  overlay: {
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0,0,0,0.85)',
    justifyContent: 'center',
    alignItems: 'center',
  },
  container: {
    width: '90%',
    maxWidth: 600,
    padding: Number(getResponsiveSize({ base: 20, md: 40 })),
    backgroundColor: '#050923',
    borderRadius: 16,
    borderWidth: 1,
    borderColor: '#182DB3',
  },
  title: {
    fontSize: Number(getResponsiveSize({ base: 24, md: 32 })),
    fontWeight: '700',
    color: '#7A8CFF',
    textAlign: 'center',
    marginBottom: 24,
  },
  text: {
    color: '#FFF',
    fontSize: Number(getResponsiveSize({ base: 16, md: 20 })),
    textAlign: 'center',
  },
  closeBtn: {
    width: '100%',
    height: Number(getResponsiveSize({ base: 44, md: 54 })),
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: Number(getResponsiveSize({ base: 24, md: 32 })),
  },
  closeBtnText: {
    color: '#FFF',
    fontSize: Number(getResponsiveSize({ base: 16, md: 18 })),
  },
});
